export default __webpack_public_path__ + "static/SolutionsMobImg-1b2094490df9e66620b0eca0a34edbc1.png";